
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import "./image.css";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles((theme) => ({
	customTooltip: {
		backgroundColor: "rgba(0, 0, 0, 0.7)",
		color: "white",
		fontSize: "12px",
		borderRadius: "3px",
		width: "250px",
		fontSize: "11px",
		opacity: "0.8",
	},
}));

const Image = ({ data }) => {
	// Use an object or array to store image URLs
	const [imgUrls, setImgUrls] = useState({});
	const [loading,setLoading] = useState(false)

	const get_image_url = async (image) => {
		try {
			const urlData = await axios.post("/get_context/getImageURL", {
				"imageName": image,
				"folderName": "audit_images"
			});
			return urlData.data;
		} catch (error) {
			console.error("Error fetching image:", error.message);
			return null;
		}
	};

	const auditDetails = Array.isArray(data.AuditDetails) ? data.AuditDetails : [];

	useEffect(() => {
		setLoading(true)
		const fetchImageUrls = async () => {
			const urls = {};
			for (const item of auditDetails) {
				const imageUrl = await get_image_url(item.imageName);
				urls[item.imageName] = imageUrl;
			}
			setLoading(false)
			setImgUrls(urls);
		};

		if (auditDetails.length > 0) {
			fetchImageUrls();
		}
	}, [auditDetails]);

	const handleDownloadClick = async (imageName) => {
		const imageSrc = imgUrls[imageName];
		const link = document.createElement("a");
		link.href = imageSrc;
		link.download = imageName;
		link.click();
	};

	const storeInfo = (imageDetails) => {
		if (!imageDetails || typeof imageDetails.storeInfo !== 'string' || typeof imageDetails.session_audit !== 'string') {
			return 'Invalid imageDetails';
		}

		const address = imageDetails.storeInfo.split("/")[3];
		const session_audit = imageDetails.session_audit;
		const date_time = moment(new Date(imageDetails.timestamp)).format("MMM DD, YYYY hh:mm a");
		const user = session_audit.split("_")[1];
		const store_code = session_audit.split("_")[3];
		const storeInfo = `${address} | ${user} | ${date_time} | ${imageDetails.imageName}`;
		return storeInfo;
	};

	const classes = useStyles();

	return (
		<Grid
			className="image-scrollbar"
			container
			spacing={2}
			style={{
				display: "grid",
				gridTemplateColumns: "repeat(70,1fr)",
				flexDirection: "row",
				overflowX: "auto",
				whiteSpace: "nowrap",
			}}
		>
			{auditDetails.length === 0 && (
				<div style={{ fontSize: "11px", marginTop: "1rem" }}>No Data</div>
			)}
			{auditDetails.length !== 0 &&
				auditDetails.map((item, index) => (
					<Grid item xs={12} sm={6} md={4} lg={4} key={index}>
						<Paper elevation={0}>
							<div style={{ position: "relative", width: "100%" }}>
								<span>
									<span
										style={{
											position: "absolute",
											top: "7px",
											left: "20rem",
											color: "white",
											zIndex: "1000",
											padding: "0.3px 7px",
											fontSize: "12px",
											backgroundColor: "rgba(0, 0, 0, 0.7)",
											opacity: "0.7",
											borderRadius: "3px",
										}}
									>
										{index + 1}
									</span>
									<div style={{ position: "relative" }}>
										<span>
											<DownloadIcon
												style={{
													cursor: "pointer",
													position: "absolute",
													top: "7px",
													left: "22rem",
													color: "white",
													zIndex: "1000",
													fontSize: "18px",
													backgroundColor: "rgba(0, 0, 0, 0.7)",
													opacity: "0.7",
													borderRadius: "3px",
												}}
												onClick={() => handleDownloadClick(item.imageName)}
											/>
										</span>
									</div>
								</span>

								
           {loading ? (
									// Show loading spinner while images are loading
									<div style={{ display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",width: "400px",
										height: "82vh",}}>
										<CircularProgress />
										<div>Loading image...</div>
									</div>
								) : (
									// Show image when loaded
									<img
									src={imgUrls[item.imageName]}
									alt={item.imageName}
									style={{
										width: "400px",
										height: "82vh",
										display: "block",
									}}
									loading="lazy"
								/> 
								)}
								<Tooltip
									title={storeInfo(item)}
									placement="top"
									classes={{ tooltip: classes.customTooltip }}
									arrow
								>
									<div style={{ position: "relative", width: "400px" }}>
										<span
											style={{
												position: "absolute",
												bottom: "0px",
												left: "0px",
												color: "white",
												zIndex: "1000",
												fontSize: "10px",
												maxWidth: "100%",
												padding: "2px 0",
												whiteSpace: "nowrap",
												overflow: "hidden",
												textOverflow: "ellipsis",
												backgroundColor: "rgba(0, 0, 0, 0.7)",
												opacity: "0.7",
											}}
										>
											{storeInfo(item)}
										</span>
									</div>
								</Tooltip>
							</div>
						</Paper>
					</Grid>
				))}
		</Grid>
	);
};

export default Image;
